module.exports = __webpack_public_path__ + "static/img/UBC老师_Alex.4eeff25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC老师_Alex.png
// module id = khGY
// module chunks = 0